import './style.scss';
import 'ShopUiBundle/components/atoms/form-check-group';
import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('form-check-card-group', () => import(/* webpackMode: "lazy" */'./form-check-card-group'));
